import { Ortak } from './../../../../providers/ortak';
import { BllOrtak } from './../../../../providers/bll/bll-ortak';
import { Component } from '@angular/core';
import {   NavController, NavParams, ViewController } from 'ionic-angular';

/**
 * Generated class for the KategoriEklePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-kategori-ekle',
  templateUrl: 'kategori-ekle.html',
})
export class KategoriEklePage {
  kategori:any={ID:-1,KategoriAdi:"",Sort:"",DokunmatikMi:0};
  kategoriID:any={};

  constructor(public navCtrl: NavController,
    public bllOrtak:BllOrtak,
    public ortak:Ortak,
    public viewCtrl:ViewController,
     public navParams: NavParams) {
      if (navParams.get("kategoriVw") != null) {
        this.kategoriID = navParams.get("kategoriVw");
        var data = new FormData();
        data.append("Kategori_id", this.kategoriID.ID);
        this.bllOrtak.islem(data, "KategoriGetirByID", "", false).then(a => {
          var Sonuc = <any>a;
          this.kategori = Sonuc.SonucObject;
         
        }
        )
      }
  }

  ionViewDidLoad() {
  }
  boslukKontrol() {
    var mesaj = "";
    
    if (this.kategori.KategoriAdi == null || this.kategori.BirimNKategoriAdi== "") {
      mesaj = mesaj + "Lütfen Kategori adını giriniz. <br/>";
    }

    if (mesaj == "") {
      return true;
    }
    else {
      this.ortak.showBasicAlert("Uyarı", mesaj);
      return false;
    }
  }
  kaydet() {

    var formData = new FormData();
   
    if (this.boslukKontrol()) {
      formData.append("kategori_json", JSON.stringify(this.kategori));
     
      this.bllOrtak.islem(formData, "KategoriEkleGuncelle", "", false).then(a => {
        var sonuc = <any>a;
        if(sonuc.Sonuc==1) this.ortak.showBasicAlert("Başarılı","İşlem Başarılı");
       

      })
    }
    this.cikis();
    }
    cikis()
    {
      this.viewCtrl.dismiss();
    }

}



// WEBPACK FOOTER //
// ./src/pages/Yonetim/KategoriIslemleri/kategori-ekle/kategori-ekle.ts